export const trafficQuestions = [
  {
    questionNumber: 1,
    choices: {
      A: "The passenger is checking in at the counter.",
      B: "The woman is boarding the plane.",
      C: "The employee is inspecting a suitcase.",
      D: "The traveler is walking through airport security.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 승객이 카운터에서 체크인하고 있음\n" +
      "오답 설명: (B) 비행기에 탑승하지 않음, (C) 가방을 검사하지 않음, (D) 공항 보안 검색대를 통과하지 않음",
  },
  {
    questionNumber: 2,
    choices: {
      A: "The woman is handing her passport to an agent.",
      B: "The woman is using a machine.",
      C: "The woman is walking through airport security.",
      D: "The woman is waiting at the boarding gate.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 여자가 키오스크같은 기계를 사용하고 있음\n" +
      "오답 설명: (A) 직원에게 여권을 주지 않음, (C) 보안 검색대를 통과하지 않음, (D) 탑승구에서 기다리지 않음",
  },
  {
    questionNumber: 3,
    choices: {
      A: "The family is walking through airport security.",
      B: "The man is placing his luggage on a conveyor belt.",
      C: "The man is handing over travel documents.",
      D: "The woman is checking a flight schedule.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 남자가 여행 서류를 건네고 있음\n" +
      "오답 설명: (A) 보안 검색대를 통과하지 않음, (B) 수하물을 컨베이어 벨트에 올리지 않음, (D) 비행 일정을 확인하지 않음",
  },
  {
    questionNumber: 4,
    choices: {
      A: "The woman is fastening her seatbelt.",
      B: "The woman is talking to a flight attendant.",
      C: "The woman is walking down the airplane aisle.",
      D: "The woman is storing her bag in the overhead compartment.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 여자가 가방을 머리 위 수납장에 넣고 있음\n" +
      "오답 설명: (A) 안전벨트를 매지 않음, (B) 승무원과 대화하지 않음, (C) 통로를 걷지 않음",
  },
  {
    questionNumber: 5,
    choices: {
      A: "The man is checking in at the counter.",
      B: "The man is sitting with his luggage.",
      C: "The man is boarding the airplane.",
      D: "The man is talking to an airport staff member.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 남자가 수하물과 함께 앉아있음\n" +
      "오답 설명: (A) 카운터에서 체크인하지 않음, (C) 비행기에 탑승하지 않음, (D) 공항 직원과 대화하지 않음",
  },
  {
    questionNumber: 6,
    choices: {
      A: "The man is sitting on a bench.",
      B: "The man is checking in at the airport counter.",
      C: "The man is pulling a suitcase.",
      D: "The man is waiting at the baggage claim area.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 남자가 캐리어를 끌고 있음\n" +
      "오답 설명: (A) 벤치에 앉아있지 않음, (B) 체크인 카운터에 있지 않음, (D) 수하물 찾는 곳에서 기다리지 않음",
  },
  {
    questionNumber: 7,
    choices: {
      A: "The man is placing his laptop into his luggage.",
      B: "A laptop is placed on the man's lap.",
      C: "The man is resting his feet on his luggage.",
      D: "The man is reading a newspaper.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 노트북이 남자의 무릎 위에 놓여있음\n" +
      "오답 설명: (A) 노트북을 가방에 넣지 않음, (C) 발을 수하물 위에 올려놓지 않음, (D) 신문을 읽지 않음",
  },
  {
    questionNumber: 8,
    choices: {
      A: "The woman is checking her luggage at the counter.",
      B: "The woman is making a phone call.",
      C: "The woman is looking at the flight information board.",
      D: "The woman is walking toward the security checkpoint.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 여자가 항공편 안내 게시판을 보고 있음\n" +
      "오답 설명: (A) 카운터에서 수하물을 체크인하지 않음, (B) 전화 통화를 하지 않음, (D) 보안 검색대로 걷지 않음",
  },
  {
    questionNumber: 9,
    choices: {
      A: "The woman is scanning a boarding pass.",
      B: "The passenger is going through airport security.",
      C: "The security officer is checking a passport.",
      D: "The woman is picking up her luggage from the conveyor belt.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 승객이 공항 보안 검색대를 통과하고 있음\n" +
      "오답 설명: (A) 탑승권을 스캔하지 않음, (C) 여권을 확인하지 않음, (D) 컨베이어 벨트에서 수하물을 찾지 않음",
  },
  {
    questionNumber: 10,
    choices: {
      A: "The passengers are stepping off the bus.",
      B: "The people are getting on the bus.",
      C: "The bus doors are being closed.",
      D: "The woman is waiting for the next bus.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 사람들이 버스에 탑승하고 있음\n" +
      "오답 설명: (A) 버스에서 내리지 않음, (C) 문이 닫히지 않고 열려있음, (D) 다음 버스를 기다리지 않음",
  },
  {
    questionNumber: 11,
    choices: {
      A: "The woman is boarding a bus.",
      B: "The woman is getting off a bus.",
      C: "The woman is waiting at a bus stop.",
      D: "The woman is crossing the street.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 여자가 버스 정류장에서 기다리고 있음\n" +
      "오답 설명: (A) 버스에 탑승하지 않음, (B) 버스에서 내리지 않음, (D) 길을 건너지 않음",
  },

  {
    questionNumber: 12,
    choices: {
      A: "The passengers are getting onto the bus.",
      B: "The man is entering the bus with his suitcase.",
      C: "The man is leaving the bus with his luggage.",
      D: "The woman is waiting near the bus stop.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 남자가 수하물을 들고 버스에서 내리고 있음\n" +
      "오답 설명: (A) 승객들이 버스에 타지 않음, (B) 가방을 들고 버스에 타지 않음, (D) 버스 정류장 근처에서 기다리지 않음",
  },
  {
    questionNumber: 13,
    choices: {
      A: "The passengers are stepping off the train.",
      B: "The train is departing.",
      C: "The man is getting onto the train.",
      D: "The passengers are waiting on the platform.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 남자가 열차에 탑승하고 있음\n" +
      "오답 설명: (A) 승객들이 열차에서 내리지 않음, (B) 열차가 멈춰있음, (D) 승강장에서 기다리지 않음",
  },

  {
    questionNumber: 14,
    choices: {
      A: "The man is driving.",
      B: "The man is adjusting his seat.",
      C: "The man is fastening his seatbelt.",
      D: "The man is checking the side mirror.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 남자가 안전벨트를 매고 있음\n" +
      "오답 설명: (A) 운전하지 않고 안전벨트를 매는 중임, (B) 좌석을 조절하지 않음, (D) 사이드미러를 확인하지 않음",
  },
  {
    questionNumber: 15,
    choices: {
      A: "The woman is adjusting the side mirror.",
      B: "The woman is fastening her seatbelt.",
      C: "The woman is adjusting the rearview mirror.",
      D: "The woman is checking the GPS screen.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 여자가 백미러를 조정하고 있음\n" +
      "오답 설명: (A) 사이드미러를 조정하지 않음, (B) 안전벨트를 매지 않음, (D) GPS 화면을 확인하지 않음",
  },

  {
    questionNumber: 16,
    choices: {
      A: "The man is checking the oil level in his car.",
      B: "The man is refueling his car.",
      C: "The man is washing his car at a gas station.",
      D: "The man is replacing a car tire.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 남자가 차에 연료를 보충하고 있음\n" +
      "오답 설명: (A) 엔진오일을 확인하지 않음, (C) 주유소에서 세차하지 않음, (D) 타이어를 교체하지 않음",
  },
  {
    questionNumber: 17,
    choices: {
      A: "The man is checking the oil level.",
      B: "The car is being refueled.",
      C: "The man is washing the car windows.",
      D: "The man is unplugging a charging cable.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 차가 주유되고 있음\n" +
      "오답 설명: (A) 오일 레벨을 확인하지 않음, (C) 차 창문을 닦지 않음, (D) 충전 케이블을 뽑지 않음",
  },
  {
    questionNumber: 18,
    choices: {
      A: "The pedestrian is crossing the street.",
      B: "The pedestrian is waiting for the traffic light.",
      C: "The pedestrian is walking on the sidewalk.",
      D: "The pedestrian is standing next to a parked car.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 보행자가 길을 건너고 있음\n" +
      "오답 설명: (B) 신호등을 기다리지 않음, (C) 인도를 걷지 않음, (D) 주차된 차 옆에 서있지 않음",
  },

  {
    questionNumber: 19,
    choices: {
      A: "The man is securing a bicycle on a roof rack.",
      B: "The man is sitting on a bicycle.",
      C: "The man is repairing the brakes on his bike.",
      D: "The man is carrying his bike up the stairs.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 남자가 자전거를 차량 지붕 거치대에 고정하고 있음\n" +
      "오답 설명: (B) 자전거에 앉아있지 않음, (C) 자전거 브레이크를 수리하지 않음, (D) 계단으로 자전거를 운반하지 않음",
  },

  {
    questionNumber: 20,
    choices: {
      A: "People are boarding a train at the station.",
      B: "Some tourists are taking pictures inside a cruise ship.",
      C: "A group of people is walking along a pier.",
      D: "Workers are unloading cargo from a ship.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 사람들이 부두를 따라 걷고 있음\n" +
      "오답 설명: (A) 기차역에서 탑승하지 않음, (B) 크루즈 선내에서 사진 찍지 않음, (D) 화물을 하역하지 않음",
  },
  {
    questionNumber: 21,
    choices: {
      A: "People are waiting for their luggage at the baggage claim.",
      B: "Passengers are boarding an airplane.",
      C: "A plane is taking off from the runway.",
      D: "Some travelers are checking in at the airport counter.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 승객들이 비행기에 탑승하고 있음\n" +
      "오답 설명: (A) 수하물 찾는 곳에서 기다리지 않음, (C) 비행기가 이륙하지 않음, (D) 체크인 카운터에서 수속하지 않음",
  },
  {
    questionNumber: 22,
    choices: {
      A: "The passengers are boarding the aircraft.",
      B: "A group of people is waiting at a bus stop.",
      C: "The travelers are disembarking from the airplane.",
      D: "People are walking toward the airport check-in counter.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 여행객들이 비행기에서 내리고 있음\n" +
      "오답 설명: (A) 비행기에 탑승하지 않음, (B) 버스 정류장에서 기다리지 않음, (D) 체크인 카운터로 걸어가지 않음",
  },
  {
    questionNumber: 23,
    choices: {
      A: "The passengers are boarding a ferry.",
      B: "Some people are sitting inside a restaurant.",
      C: "A group of people is relaxing on a cruise deck.",
      D: "Tourists are taking pictures in front of a hotel.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 사람들이 크루즈 갑판에서 휴식을 취하고 있음\n" +
      "오답 설명: (A) 배에 승선하지 않음, (B) 식당 내부가 아닌 크루즈 갑판임, (D) 호텔 앞에서 사진 찍지 않음",
  },
  {
    questionNumber: 24,
    choices: {
      A: "A group of people is fishing on a boat.",
      B: "Some men are rowing a boat in the water.",
      C: "The athletes are playing water polo.",
      D: "A team is sailing on a yacht.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 남자들이 물 위에서 보트를 노 저어 이동하고 있음\n" +
      "오답 설명: (A) 낚시를 하지 않음, (C) 수구 경기를 하지 않음, (D) 요트를 타고 있지 않음",
  },
  {
    questionNumber: 25,
    choices: {
      A: "The children are playing on the beach.",
      B: "Some kids are standing on a sailing yacht.",
      C: "A family is swimming in the ocean.",
      D: "The boat is docked at the harbor.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 아이들이 세일링 요트 위에 서있음\n" +
      "오답 설명: (A) 해변이 아닌 요트 위에 있음, (C) 바다에서 수영하지 않음, (D) 항구에 정박하지 않고 항해 중임",
  },
  {
    questionNumber: 26,
    choices: {
      A: "A man is fishing from a boat.",
      B: "The man is paddling a kayak across the water.",
      C: "A group of people is sailing on a yacht.",
      D: "The man is rowing a boat with an oar.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 남자가 카약을 패들로 저어 이동하고 있음\n" +
      "오답 설명: (A) 낚시를 하지 않음, (C) 요트를 타고 있지 않음, (D) 조정용 노가 아닌 패들을 사용 중임",
  },
  {
    questionNumber: 27,
    choices: {
      A: "The man is walking while holding a bicycle.",
      B: "A man is riding a bicycle along the street.",
      C: "A cyclist is fixing the chain of his bike.",
      D: "The man is getting off a bus.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 남자가 길을 따라 자전거를 타고 있음\n" +
      "오답 설명: (A) 자전거를 들고 걷지 않음, (C) 자전거 체인을 수리하지 않음, (D) 버스에서 내리지 않음",
  },
  {
    questionNumber: 28,
    choices: {
      A: "The cyclist is checking her phone while riding a bike.",
      B: "A woman is standing next to a bicycle at a crosswalk.",
      C: "A woman is cycling across a pedestrian crossing.",
      D: "The woman is adjusting her helmet before starting her ride.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 여성이 횡단보도를 자전거를 타고 건너고 있음\n" +
      "오답 설명: (A) 휴대폰을 보고 있지 않음, (B) 자전거 옆에 서있지 않고 타고 있음, (D) 헬멧을 조정하지 않음",
  },
  {
    questionNumber: 29,
    choices: {
      A: "Some people are fixing their bicycles on the side of the road.",
      B: "A group of cyclists is participating in a race.",
      C: "The riders are taking a break at a rest stop.",
      D: "Several people are walking along the street.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 사이클리스트들이 도로에서 경주에 참가하고 있음\n" +
      "오답 설명: (A) 자전거를 수리하지 않음, (C) 휴게소에서 쉬지 않음, (D) 길을 걷고 있지 않음",
  },
  {
    questionNumber: 30,
    choices: {
      A: "The man is pushing a bicycle along the sidewalk.",
      B: "A cyclist is riding a bike on a busy street.",
      C: "The man is fixing the chain of his bicycle.",
      D: "A person is parking a bike at a bike rack.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 남자가 인도를 따라 자전거를 밀며 걷고 있음\n" +
      "오답 설명: (B) 자전거를 타지 않고 걷고 있음, (C) 자전거 체인을 수리하지 않음, (D) 자전거 거치대에 주차하지 않음",
  },
  {
    questionNumber: 31,
    choices: {
      A: "The man is tying his shoelaces.",
      B: "The man has his hand in his pocket.",
      C: "The man is adjusting his tie.",
      D: "The man is opening his suitcase.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 남자가 주머니에 손을 넣고 있음\n" +
      "오답 설명: (A) 신발끈을 묶고 있지 않음, (C) 넥타이를 고치고 있지 않음, (D) 서류가방을 열고 있지 않음",
  },
  {
    questionNumber: 32,
    choices: {
      A: "The woman is sitting on a bench.",
      B: "The woman is walking through the airport.",
      C: "The woman is facing the window.",
      D: "The woman is talking on the phone.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 여자가 창문을 향해 서있음\n" +
      "오답 설명: (A) 벤치에 앉아있지 않음, (B) 공항을 걷고 있지 않음, (D) 전화 통화를 하고 있지 않음",
  },
  {
    questionNumber: 33,
    choices: {
      A: "The man is packing his suitcase.",
      B: "The man is sitting with his legs crossed.",
      C: "The man is standing near a window.",
      D: "The man is talking on the phone.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 남자가 다리를 꼬고 앉아있음\n" +
      "오답 설명: (A) 가방을 싸고 있지 않음, (C) 창문 근처에 서있지 않음, (D) 전화 통화를 하고 있지 않음",
  },
  {
    questionNumber: 34,
    choices: {
      A: "The man is leaning back on a chair.",
      B: "The man is sitting on a chair.",
      C: "The man is leaning forward while looking at his phone.",
      D: "The man is standing near the entrance.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 남자가 앞으로 몸을 기울이며 휴대폰을 보고 있음\n" +
      "오답 설명: (A) 의자에 기대어 뒤로 기대고 있지 않음, (B) 의자가 아닌 수트케이스에 앉아있음, (D) 입구 근처에 서있지 않음",
  },
  {
    questionNumber: 35,
    choices: {
      A: "The woman is walking through the airport.",
      B: "The woman is carrying her suitcase.",
      C: "The woman is putting her feet up on the suitcase.",
      D: "The woman is checking her boarding pass.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 여자가 가방 위에 발을 올리고 있음\n" +
      "오답 설명: (A) 공항을 걷고 있지 않음, (B) 가방을 들고 있지 않음, (D) 탑승권을 확인하고 있지 않음",
  },
  {
    questionNumber: 36,
    choices: {
      A: "The woman is walking across the terminal.",
      B: "The suitcase is open on the floor.",
      C: "The shoes have been taken off.",
      D: "The woman is putting on her shoes.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 신발이 벗겨져 있음\n" +
      "오답 설명: (A) 터미널을 걷고 있지 않음, (B) 가방이 바닥에 열려있지 않음, (D) 신발을 신고 있지 않음",
  },
  {
    questionNumber: 37,
    choices: {
      A: "The woman is opening the overhead compartment.",
      B: "The woman is fastening her seatbelt.",
      C: "The woman is walking down the aisle.",
      D: "The woman is looking out the window.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 여자가 머리 위 수납장을 열고 있음\n" +
      "오답 설명: (B) 안전벨트를 매고 있지 않음, (C) 통로를 걷고 있지 않음, (D) 창밖을 보고 있지 않음",
  },
  {
    questionNumber: 38,
    choices: {
      A: "The man is looking at his phone.",
      B: "The man is shaking hands with someone.",
      C: "The man is waving.",
      D: "The man is carrying a suitcase up the stairs.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 남자가 손을 흔들고 있음\n" +
      "오답 설명: (A) 휴대폰을 보고 있지 않음, (B) 누군가와 악수하고 있지 않음, (D) 계단을 올라가며 가방을 들고 있지 않음",
  },
];
